"use client";

import PropTypes from "prop-types";
import { usePathname } from "next/navigation";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";

export default function Stepper({ next, prev }) {
  const pathname = usePathname();
  const isGuidesPage = pathname.includes("/guides/");

  const prevButtonText = prev?.btnText
    ? prev?.btnText
    : isGuidesPage
    ? "Previous Guide"
    : "Previous Page";
  const nextButtonText = next?.btnText
    ? next?.btnText
    : isGuidesPage
    ? "Next Guide"
    : "Next Page";

  return (
    <nav className="sm:flex justify-between mt-6 bg-gray-100 border lg:border-0 lg:border-t border-gray-200 rounded lg:rounded-none">
      {prev && (
        <a
          href={prev.url}
          className="group relative block w-full p-4 pl-10 border-b sm:border-b-0 sm:border-r border-gray-200 no-underline"
        >
          <span className="block mb-1 c-heading--caps font-medium text-gray-500">
            {prevButtonText}
          </span>

          <span className="block text-lg text-gray-700 group-hover:text-blue transition duration-300">
            {prev.text}
          </span>

          <FontAwesomeIcon
            icon={faArrowLeft}
            size="sm"
            className="absolute top-1/2 left-4 -translate-y-1/2 text-gray-700"
          />
        </a>
      )}

      {next && (
        <a
          href={next.url}
          className="group relative block w-full p-4 pl-10 sm:pl-4 sm:pr-10 text-left sm:text-right no-underline"
        >
          <span className="block mb-1 c-heading--caps font-medium text-gray-500">
            {nextButtonText}
          </span>

          <span className="block text-lg text-gray-700 group-hover:text-blue transition duration-300">
            {next.text}
          </span>

          <FontAwesomeIcon
            icon={faArrowRight}
            size="sm"
            className="absolute top-1/2 left-4 sm:left-auto sm:right-4 -translate-y-1/2 text-gray-700"
          />
        </a>
      )}
    </nav>
  );
}

Stepper.propTypes = {
  next: PropTypes.shape({
    btnText: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  prev: PropTypes.shape({
    btnText: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
};
